import { render, staticRenderFns } from "./FooterNewsletter.vue?vue&type=template&id=2406dd50&scoped=true&"
import script from "./FooterNewsletter.vue?vue&type=script&lang=js&"
export * from "./FooterNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./FooterNewsletter.vue?vue&type=style&index=0&id=2406dd50&scoped=true&lang=scss&scooped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406dd50",
  null
  
)

/* custom blocks */
import block0 from "@/locales/footer_newsletter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FFooter%2FFooterNewsletter.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports